<template>
  <app-details-sidebar
    :sidebar-title="getTitle"
    :show-sidebar="getShowSidebar"
    @hideSidebar="hideSidebar($event)"
    @editItem="editItem"
    @deleteItem="deleteItem"
  >
    <template v-if="detailedItem" v-slot:detailsHeader>
      <p v-if="!detailedItem.isThereABalance">No balance on this vehicle</p>

    </template>

    <template v-if="detailedItem" v-slot:detailsContent>

      <app-delete-dialog :value="deleteDialog"
                         @delete="deleteVehicleItem(detailedItem.id)"
                         @close="closeDialog">
        Are you sure you want to delete this vehicle?
      </app-delete-dialog>

      <div :class="$forms.detailsTable">
        <div :class="$forms.title">Main Information</div>
        <div :class="$forms.main">
          <div :class="$forms.mainRow">
            <h6>Current Value</h6>
            <p>{{ detailedItem.currentValue | currency }}</p>
          </div>

          <div :class="$forms.mainRow">
            <h6>Year Purchased / Leased</h6>
            <p>{{ detailedItem.yearPurchased }}</p>
          </div>

          <div :class="$forms.mainRow">
            <h6 :class="getDetailRowStyle">Monthly Payment(s)</h6>
            <p v-if="detailedItem.isThereABalance">{{ detailedItem.monthlyPayment | currency }}</p>
            <p v-else :class="$style.transparent">n/a</p>
          </div>

          <div :class="$forms.mainRow">
            <h6 :class="getDetailRowStyle">Balance Owed</h6>
            <p v-if="detailedItem.isThereABalance">{{ detailedItem.balanceOwed | currency }}</p>
            <p v-else :class="$style.transparent">n/a</p>
          </div>

          <div :class="$forms.mainRow">
            <h6 :class="getDetailRowStyle">Final Payment</h6>
            <p v-if="detailedItem.isThereABalance">
              {{ detailedItem.finalPaymentMonth | displayMonth }}
              <template v-if="detailedItem.finalPaymentYear > 0">
                {{ detailedItem.finalPaymentYear }}
              </template>
            </p>
            <p v-else :class="$style.transparent">n/a</p>
          </div>

          <div :class="$forms.mainRow">
            <h6>Vehicle Year</h6>
            <p>{{ detailedItem.modelYear }}</p>
          </div>

          <div :class="$forms.mainRow">
            <h6>Vehicle Make</h6>
            <p>{{ detailedItem.make }}</p>
          </div>

          <div :class="$forms.mainRow">
            <h6>Vehicle Model</h6>
            <p>{{ detailedItem.model }}</p>
          </div>


        </div>
      </div>
    </template>

  </app-details-sidebar>
</template>

<script>
import currency from 'currency.js';
import { mapActions, mapGetters } from 'vuex';
import { transformMonthToString } from '@/utils/transforms';
import { MONTHS, VEHICLE_TYPES } from '@/constants';

export default {
  props: {
    showSidebar: {
      type: Boolean,
      default: false,
    },
    detailedItem: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      deleteDialog: false,
    };
  },
  methods: {
    ...mapActions([
      'deleteVehicle',
    ]),
    hideSidebar(e) {
      this.$emit('hideSidebar', e);
    },
    editItem() {
      this.hideSidebar();
      this.$emit('editItem', this.detailedItem, this.detailedItem.id);
    },
    deleteItem() {
      this.deleteDialog = true;
    },
    closeDialog() {
      this.deleteDialog = false;
    },
    /* Delete vehicle item by click at the Delete button in the dialog */
    deleteVehicleItem(id) {
      this.deleteVehicle({
        id,
        userId: this.getUserId,
      }).then(() => {
        this.closeDialog();
        this.hideSidebar();
      });
    },
  },
  computed: {
    ...mapGetters([
      'getUserId',
    ]),
    getMonths() {
      return MONTHS;
    },
    getVehicleTypes() {
      return VEHICLE_TYPES.map(type => type.textValue);
    },
    getShowSidebar() {
      return this.showSidebar;
    },
    getTitle() {
      if (this.detailedItem && this.detailedItem.vehicleType) {
        return VEHICLE_TYPES.find(type => type.code === this.detailedItem.vehicleType).textValue;
      }

      return '';
    },
    getDetailRowStyle() {
      if (this.detailedItem.isThereABalance) {
        return false;
      }
      return this.$style.transparent;
    },
  },
  directives: {
    currency,
  },
  filters: {
    displayVehicle(value) {
      return VEHICLE_TYPES.find(type => type.code === value).textValue;
    },
    displayMonth(value) {
      return transformMonthToString(value);
    },
  },
};
</script>

<style src="@/styles/forms.scss" lang="scss" module="$forms"></style>

<style lang="scss" module>
@import "@/styles/variables.scss";

.transparent {
  opacity: 0.4;
}
</style>
